import React from "react";
import ReactDOM from "react-dom";
import styled, { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
import { createGlobalStyle } from "styled-components";

import CookieBanner from "auth/CookieBanner";
import Flame from "components/svg/swi-flame.svg";
import Register from "auth/Register";
import ResendConfirmation from "auth/ResendConfirmation";
import currentTheme from "colorTheme/currentTheme";
import { globalStyles } from "components/globalStyles";
import texture from "assets/texture.png";
import { createStoreFromState, history } from "utils/store";

const store = createStoreFromState({}, window.devToolsExtension);

const GlobalStyle = createGlobalStyle`
  ${globalStyles}

  body {
    padding: 0;
  }
`;

const BackgroundFlame = styled(Flame)`
  path {
    fill: #000;
    opacity: 0.06;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  background: url(${texture}) #222;
  overflow: hidden;

  > svg {
    position: absolute;
    height: 100%;
    z-index: 1;
  }

  > div {
    position: relative;
    z-index: 10;
  }
`;

const withTexturedBackground = WrappedComponent => {
  return class TexturedBackground extends React.Component {
    render() {
      return (
        <Wrapper>
          <BackgroundFlame />
          <CookieBanner />
          <WrappedComponent {...this.props} />
          <GlobalStyle />
        </Wrapper>
      );
    }
  };
};

ReactDOM.render(
  <ThemeProvider theme={currentTheme}>
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route
            path="/sign_up"
            exact
            component={withTexturedBackground(Register)}
          />
          <Route
            path="/sign_up/:edition"
            component={withTexturedBackground(Register)}
          />
          <Route
            path="/users/"
            exact
            component={withTexturedBackground(Register)}
          />
          <Route
            path="/users/:edition"
            component={withTexturedBackground(Register)}
          />
          <Route
            path="/users/sign_up"
            component={withTexturedBackground(Register)}
          />
          <Route
            path="/users/confirmation/"
            exact
            component={withTexturedBackground(ResendConfirmation)}
          />
          <Route
            path="/users/confirmation/new"
            component={withTexturedBackground(ResendConfirmation)}
          />
        </Switch>
      </Router>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);
